<template>
        <b-card
        header="Indicadores del Periodo"
        header-tag="header"
    >
        <div slot="header">
            <app-sub-title text="Indicadores del Periodo"></app-sub-title>
        </div>
        <b-card-body>
            <b-container fluid>
                <b-row>
                    <b-col cols="12" md="4">
                        <app-figure title="Asignaciones">
                            {{ figures.assignations }}
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Resueltas">
                            {{ figures.answered }}
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Efectividad" :status="getEfectivenessStatus()">
                            {{ figures.answered / figures.assignations * 100 | decimal(0) }} %
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Abiertas">
                            {{ figures.open }}
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Resueltas Vencidas" :status="getResolvedOverdueStatus()">
                            {{ figures.answeredOverdue }} ({{ !!figures.answered? (figures.answeredOverdue / figures.answered * 100): 0 | decimal(2) }} %)
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Abiertas Vencidas" :status="getOpenOvedueStatus()">
                            {{ figures.openOverdue }}
                        </app-figure>
                    </b-col>
                </b-row>
            </b-container>
        </b-card-body>
    </b-card>
</template>
<script>
import Figure from '../../../../../UI/Reports/Figure';
export default {
    name: 'pqr_user_figures_period',
    components: {
        appFigure: Figure
    },
    props: ['figures'],
    methods: {
        getEfectivenessStatus() {
            const efectiveness = this.figures.answered / this.figures.assignations * 100;

            if(efectiveness === 100) return 'success';

            return efectiveness < 80? 'error': 'normal';
        },
        getResolvedOverdueStatus() {
            const ind = (this.figures.answeredOverdue / this.figures.answered * 100);
            if(!this.figures.answered || ind === 0) return 'success';

            return ind > 10? 'error': 'normal';
        },
        getOpenOvedueStatus() {
            return this.figures.openOverdue === 0? 'success': 'error';
        }
    }
}
</script>